const Logo = (props) => (
  <img
    className="logo"
    alt="Logo"
    // src="/static/logo.svg"
    src="/static/logo.png"
    style={{width: 32, height: 32, margin: 10}}
    {...props}
  />
);

export default Logo;
